import React, { useEffect, useRef, useState } from "react";
import { MainLayout } from "../../../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../redux";
import {
  useBookMentorSlotMutation,
  useGetMentorPackagesByIdQuery,
  useGetMentorUsingIdQuery,
  useLazyGetSlotsByMentorIdQuery,
  useProfileUserQuery,
} from "../../../../redux/rtk-api";
import { handleError } from "../../../../redux/features";
import { AppButton } from "../../../../component";
import {
  AiOutlineCalendar,
  AiOutlineLeft,
  AiOutlineLoading,
  AiOutlineMessage,
  AiOutlinePhone,
  AiOutlineVideoCamera,
} from "react-icons/ai";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

import moment from "moment";
import clsx from "clsx";
import { MdOutlineFormatQuote } from "react-icons/md";
import { Helmet } from "react-helmet";
import DOMPurify from "dompurify";
import { useGetMyWalletQuery } from "../../../../redux/rtk-api/buddy-coin.api";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { callType, ICategoryProps } from "../../../../interface";
import { toast } from "react-toastify";
import { Box, Input, Text } from "@chakra-ui/react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import BookingPanel from "./component/booking";
import LeftComponent from "./component/LeftComponent";
import RightComponent from "./component/RightComponent";
export const UserMentorDetailsPage = () => {
  const navigate = useNavigate();
  const [confirmModel, setConfirmModel] = useState<boolean>(false);
  const [scheduleModel, setScheduleModel] = useState<boolean>(false);
  const [selectTime, setSelectTime] = useState<number>(5);
  const [selectTimeHour, setSelectTimeHour] = useState<string>("");
  const [selectType, setSelectType] = useState<string>("time");
  const [selectedPrice, setSelectedPrice] = useState<number>(0);

  const [selectedTimeSlot, setSelectedTimeSlot] = useState({
    date: "",
    slot: "",
    _id: "",
  });
  // const [callType, setCallType] = useState<callType | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const {
    isError: isMentorError,
    isLoading: isMentorLoading,
    data: mentor,
    error: mentorError,
  } = useGetMentorUsingIdQuery(id as string);
  const { data: packages } = useGetMentorPackagesByIdQuery(id as string);
  const [
    GetMentorSlots,
    {
      isError: isSlotError,
      error: slotError,
      isLoading: isSlotLoading,
      data: slotData,
    },
  ] = useLazyGetSlotsByMentorIdQuery();
  const {
    data: profile,
    isError: isProfileError,
    error: profileError,
  } = useProfileUserQuery();
  const [
    BookSlotWithMentor,
    {
      isError: isBookSlotError,
      isLoading: isBookSlotLoading,
      data: bookSlotData,
      error: bookSlotError,
      isSuccess: isBookSuccess,
    },
  ] = useBookMentorSlotMutation();
  const { data: wallet } = useGetMyWalletQuery();

  useEffect(() => {
    if (isMentorError) {
      if ((mentorError as any)?.data) {
        dispatch(handleError((mentorError as any)?.data.message));
      } else {
        console.log(mentorError);
      }
    }
    if (isBookSlotError) {
      if ((bookSlotError as any).data) {
        console.log((bookSlotError as any).data);
        dispatch(handleError((bookSlotError as any).data.message));
      } else {
        console.log(bookSlotError);
      }
    }
    if (isSlotError) {
      if ((slotError as any)?.data) {
        dispatch(handleError((slotError as any)?.data.message));
      } else {
        console.log(slotError);
      }
    }
    if (isProfileError) {
      if ((profileError as any)?.data) {
        dispatch(handleError((profileError as any)?.data.message));
      } else {
        console.log(profileError);
      }
    }

    if (id) {
      (async () => {
        await GetMentorSlots(id);
      })();
    }
  }, [
    isMentorError,
    mentorError,
    dispatch,
    id,
    GetMentorSlots,
    isSlotError,
    slotError,
    isProfileError,
    profileError,
    isBookSlotError,
    bookSlotError,
    bookSlotData,
  ]);

  useEffect(() => {
    if (isBookSuccess) {
      if (selectType == "time") {
        window.open(bookSlotData?.data?.link, "_blank");
        setConfirmModel(false);
      } else {
        toast.success(bookSlotData?.data?.message);
        setSelectedTimeSlot({
          date: "",
          slot: "",
          _id: "",
        });
        setScheduleModel(false);
        setCallType(null);
        setConfirmModel(false);
      }
    }
  }, [isBookSuccess, bookSlotData?.data]);

  const BookSlot = async ({
    userId,
    slotId,
    mentorId,
    callType,
    type,
    time,
  }: {
    userId: string;
    slotId: string;
    callType: string;
    mentorId: string;
    type: string;
    time: number;
  }) => {
    if (!callType) {
      toast.warn("Please try again");
    } else {
      await BookSlotWithMentor({
        slotId,
        userId,
        mentorId,
        type,
        time,
        callType: callType,
      });
    }
  };

  const timeOptions = [5, 10, 15, 20];

  const cleanHTML = DOMPurify.sanitize(mentor?.data?.description);

  const [showLinks, setShowLinks] = useState(false);

  const toggleLinks = () => setShowLinks(!showLinks);

  const [accept, setAccept] = useState<boolean>(false);

  const handlePrivacyAccept = () => {
    setAccept(!accept);
  };

  const [showModal, setShowModal] = useState(false);

  const [selected, setSelected] = useState<Date | undefined>();
  const [selectedVideo, setSelectedVideo] = useState<Date | undefined>();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const calendarRef = useRef<HTMLDivElement>(null);

  const today = new Date();
  const maxDate = new Date(
    today.getFullYear(),
    today.getMonth() + 3,
    today.getDate()
  );

  const handleSelect = (date?: Date) => {
    setSelected(date);
    setIsOpen(false);
    if (date) {
    }
  };
  const handleSelectVideo = (date?: Date) => {
    setSelectedVideo(date);
    setIsOpenVideo(false);
    if (date) {
      console.log("Selected date:", format(date, "yyyy-MM-dd"));
    }
  };

  // Close calendar if clicked outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutsideVideo(event: MouseEvent) {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setIsOpenVideo(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutsideVideo);
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideVideo);
  }, []);

  const filteredSlots = slotData?.data?.filter(
    (slot) =>
      moment(slot.slotsDate).format("YYYY-MM-DD") ===
      moment(selected).format("YYYY-MM-DD")
  );

  // Dummy package data
  const userPackages = [
    {
      _id: "pkg001",
      remainingSessions: 3,
      type: "video",
    },
    {
      _id: "pkg002",
      remainingSessions: 1,
      type: "audio",
    },
  ];

  // Dummy group sessions
  const groupSessions = [
    {
      _id: "grp001",
      title: "Mindfulness for Beginners",
      bookedSeats: 4,
      totalSeats: 6,
    },
    {
      _id: "grp002",
      title: "Confidence Masterclass",
      bookedSeats: 2,
      totalSeats: 10,
    },
  ];

  // Dummy handlers
  const onPackageBook = (selectedPackage) => {
    console.log("Selected Package:", selectedPackage);
    setConfirmModel(true); // show confirmation modal
  };

  const onGroupBook = (selectedGroup) => {
    console.log("Joining Group Session:", selectedGroup);
    setConfirmModel(true); // show confirmation modal
  };

  const [callType, setCallType] = useState("");
  const [duration, setDuration] = useState<number | null>(null);
  const [sessionType, setSessionType] = useState(""); // single, package3, package6
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
  const [selectedDuration, setSelectedDuration] = useState<number | null>(null);
  const [preferredTime, setPreferredTime] = useState<number | "">("");
  const [category, setCategory] = useState<string | null>(null);

  const categories = [
    "Manifestation",
    "Mental Health",
    "Healing",
    "Energy Work",
    "Career Clarity",
    "Relationships",
  ];


  const [isDateOpen, setIsDateOpen] = useState(false);

  const chatDurations = [5, 10, 15, 20];
  const audioVideoDurations = [30, 45, 60];
  const durations = [5, 10, 15, 20];

  return (
    <MainLayout loading={isMentorLoading}>
      <Helmet>
        <title>
          AlterBuddy | {`${mentor?.data?.name?.firstName}`}{" "}
          {`${mentor?.data?.name?.lastName}`}
        </title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="xl:px-10 px-5 pt-10 mb-10 z-10">
        <div className="my-5">
          <button
            onClick={() => navigate("/mentor/list")}
            className="flex items-center gap-3"
          >
            <AiOutlineLeft size={30} />
            <p>Back</p>
          </button>
        </div>
        <hr />
        <div className="flex flex-row items-start gap-20 justify-between xl:lg:md:flex-nowrap flex-wrap mt-5">
          <LeftComponent mentor={mentor?.data} packages={packages?.data} />
          {/* <RightComponent
            callType={callType}
            setCallType={setCallType}
            selectedPrice={selectedPrice}
            setSelectedPrice={setSelectedPrice}
            packages={packages}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectTime={selectTime}
            setSelectTime={setSelectTime}
            setConfirmModel={setConfirmModel}
            selectTimeHour={selectTimeHour}
            setSelectTimeHour={setSelectTimeHour}
            setSelectType={setSelectType}
            selected={selected}
            setSelected={setSelected}
            selectedVideo={selectedVideo}
            setSelectedVideo={setSelectedVideo}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isOpenVideo={isOpenVideo}
            setIsOpenVideo={setIsOpenVideo}
            calendarRef={calendarRef}
            filteredSlots={filteredSlots}
            onPackageBook={onPackageBook}
            userPackages={userPackages}
            groupSessions={groupSessions}
            onGroupBook={onGroupBook}
          /> */}

          {/* <div className="xl:lg:md:flex-1">
            <div className="flex gap-10 justify-between w-full items-center">
              <div className="flex gap-10 items-center">
                <img
                  src={
                    mentor?.data?.image ||
                    "https://qph.cf2.quoracdn.net/main-qimg-5b495cdeb2ebb79cff41634e5f9ea076"
                  }
                  alt="mentor "
                  className="object-cover aspect-square w-[20%] rounded-md p-2 shadow-lg"
                />
                <div className="flex items-start flex-col">
                  <h6 className="text-3xl capitalize">
                    {mentor?.data.name.firstName} {mentor?.data.name.lastName}
                  </h6>
                  <p className="capitalize text-primary-500 text-lg mt-2">
                    {mentor?.data.category
                      .map((props) => props.title)
                      .join(", ")}
                  </p>
                  <p className="capitalize text-primary-500 text-md mt-2">
                    Qualification :{" "}
                    {mentor?.data.qualification
                      ? mentor?.data?.qualification
                      : "N/A"}
                  </p>
                  <div className="flex mt-3 gap-3 items-center">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/484/484633.png"
                      alt=""
                      width={20}
                    />
                    <p className="capitalize text-gray-900 mt-2">
                      {mentor?.data.languages.join(",  ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="my-10" />
            <div className="flex flex-col gap-5">
              <div>
                <h6 className="text-2xl flex-wrap font-libre capitalize text-primary-500">
                  About
                </h6>
                <div
                  className="no-tailwind"
                  style={{
                    all: "unset",
                    display: "block",
                    fontFamily: "inherit",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML,
                  }}
                />
              </div>

              <div>
                <div className="my-10">
                  {mentor?.data.videoLink && (
                    <video
                      className="xl:lg:md:w-full aspect-video"
                      src={mentor?.data.videoLink}
                      title="YouTube video player"
                      autoPlay={false}
                      controls
                      controlsList="nodownload nofullscreen noremoteplayback"
                    />
                  )}
                </div>
              </div>
              {packages?.data.length > 0 && (
                <div>
                  {packages?.data.map((packageList, i) => {
                    // Check if subServices are available
                    return packageList?.subServices?.length > 0 ? (
                      <div key={i} className="space-y-4">
                        <h6 className="text-2xl flex-wrap font-libre capitalize text-primary-500">
                          {(packageList.categoryId as ICategoryProps).title}{" "}
                          Service List
                        </h6>
                        <table>
                          <thead className="bg-gray-200">
                            <tr>
                              <th className="px-5 py-2 w-[40%] border-r-2 text-left">
                                Name
                              </th>
                              <th className="px-5 py-2 w-[20%] text-left">
                                Time
                              </th>
                              <th className="px-5 py-2 w-[20%] text-right">
                                BuddyCoins
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {packageList?.subServices?.map(
                              (subPackage, subIndex) => (
                                <tr
                                  className="border-b border-x"
                                  key={subIndex}
                                >
                                  <td className="px-5 py-2 w-[350px]">
                                    <p className="capitalize">
                                      {subPackage?.title}
                                    </p>
                                  </td>

                                  <td className="px-5 py-2 w-[350px]">
                                    <p className="capitalize">
                                      {subPackage?.time
                                        ? subPackage.time
                                        : "N/A"}
                                    </p>
                                  </td>
                                  <td className="px-5 py-2 w-[150px]">
                                    <p className="text-right">
                                      {subPackage?.price}
                                    </p>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : null;
                  })}
                </div>
              )}
              {packages?.data.length !== 0 && (
                <div>
                  {packages?.data.map((packageList, i) => {
                    return (
                      <div>
                        {packageList.subServices.length !== 0 && (
                          <div>
                            <h6 className="text-lg font-bold text-primary-500 uppercase">
                              note :
                            </h6>
                            <p className="">
                              Please note that the rates mentioned above are for{" "}
                              <b>readings and consultations only</b>. These
                              charges apply to sessions where the healer assess
                              your current emotional, spiritual or physical
                              state and offers guidance on their findings.
                            </p>
                            <p className="mt-3">
                              Healing services, which may be recommended after
                              the consultation, are{" "}
                              <b>customized specifically</b> to meet your
                              individual needs and are <b>separately charged</b>
                              . The healer will discuss the best healing methods
                              during your consultation, and together you can
                              decide the next steps.
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
              {mentor?.data.specialists.length > 0 && (
                <div className="bg-primary-100 p-3 rounded-md">
                  <h6 className="text-xl font-sans2 mb-2 capitalize text-primary-500">
                    What can you ask me:
                  </h6>
                  {mentor?.data?.specialists?.map((props, i) => {
                    return (
                      <div key={i} className="flex items-end gap-3">
                        <MdOutlineFormatQuote
                          size={30}
                          className="fill-primary-500"
                          fill="currentColor"
                        />
                        <p className="text-md text-gray-500 capitalize">
                          {props}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div> */}

          <div className="xl:lg:md:w-[35%]  top-20 shadow-xl border border-gray-300 p-5 rounded-lg mt-10">
            {/* <div>
              <p className="text-gray-500 my-2">
                Schedule a personal audio/video session and feel better.
              </p>
              <div className="flex items-center gap-3">
                <AiOutlineCalendar size={30} className="fill-primary-500" />
                <div>
                  <p className="text-lg text-gray-900 font-bold">
                    Book Session
                  </p>
                </div>
              </div>
            </div>
            <div className="my-5">
              <div className="flex gap-5 flex-wrap mt-3">
                <AppButton
                  outlined
                  filled={callType == "chat" ? true : false}
                  flexed
                  onClick={() => {
                    setSelectedPrice(
                      packages?.data
                        ?.filter(
                          (prop) =>
                            (prop?.categoryId as ICategoryProps)._id ===
                            selectedCategory
                        )
                        ?.find((prop) => prop?.packageType === "chat")?.price
                    );
                    // setConfirmModel(true);
                    setCallType("chat");
                    setSelectTime(5);
                  }}
                >
                  <AiOutlineMessage size={20} />
                  {packages?.data
                    .filter(
                      (prop) =>
                        (prop.categoryId as ICategoryProps)._id ===
                        selectedCategory
                    )
                    .find((prop) => prop?.packageType === "chat")?.price ||
                    selectedPrice}
                </AppButton>
                <AppButton
                  outlined
                  flexed
                  filled={callType == "audio" ? true : false}
                  onClick={() => {
                    setSelectedPrice(
                      packages?.data
                        .filter(
                          (prop) =>
                            (prop?.categoryId as ICategoryProps)._id ===
                            selectedCategory
                        )
                        ?.find((prop) => prop?.packageType === "audio")?.price
                    );
                    // setConfirmModel(true);
                    setCallType("audio");
                    setSelectTime(5);
                  }}
                >
                  <AiOutlinePhone size={20} />
                  {
                    packages?.data
                      ?.filter(
                        (prop) =>
                          (prop?.categoryId as ICategoryProps)._id ===
                          selectedCategory
                      )
                      ?.find((prop) => prop?.packageType === "audio")?.price
                  }
                </AppButton>
                <AppButton
                  outlined
                  flexed
                  filled={callType == "video" ? true : false}
                  onClick={() => {
                    setSelectedPrice(
                      packages?.data
                        .filter(
                          (prop) =>
                            (prop?.categoryId as ICategoryProps)._id ===
                            selectedCategory
                        )
                        ?.find((prop) => prop?.packageType === "video")?.price
                    );
                    // setConfirmModel(true);
                    setCallType("video");
                    setSelectTime(5);
                  }}
                >
                  <AiOutlineVideoCamera size={20} />
                  {
                    packages?.data
                      .filter(
                        (prop) =>
                          (prop?.categoryId as ICategoryProps)._id ===
                          selectedCategory
                      )
                      ?.find((prop) => prop?.packageType === "video")?.price
                  }
                </AppButton>
              </div>
              {callType == "audio" || callType == "chat" ? (
                <>
                  <div className="mt-3">
                    <label className="text-gray-900 font-bold capitalize text-sm">
                      Please enter your preferred time.
                    </label>
                    <Input
                      type="number"
                      mt={1}
                      focusBorderColor="#CBD5E1"
                      placeholder="Enter minute"
                      paddingY={0}
                      borderRadius={"5px"}
                      paddingX={"4"}
                      value={selectTime}
                      onChange={(e) => setSelectTime(parseInt(e.target.value))}
                      border={"2px solid #CBD5E1"}
                    />
                  </div>
                  <div className="flex gap-2 flex-wrap mt-3">
                    <div>
                      <label
                        className="text-gray-900 font-bold capitalize text-sm"
                        htmlFor="date"
                      >
                        Popular among users
                      </label>
                    </div>
                    <div>
                      {timeOptions.map((time) => (
                        <button
                          key={time}
                          onClick={() => {
                            setSelectTime(time);
                            setSelectType("time");
                          }}
                          className={clsx(
                            "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50 mr-5",
                            selectTime === time && "bg-primary-500"
                          )}
                        >
                          <p
                            className={clsx(
                              "w-full text-primary-500",
                              selectTime === time &&
                                "text-white group-hover:text-white"
                            )}
                          >
                            {time} Mins
                          </p>
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              {callType == "video" ? (
                <>
                  <div className="flex gap-5 flex-wrap my-3">
                    <button
                      onClick={() => {
                        setSelectTime(45);
                        setSelectType("slot");
                      }}
                      className={clsx(
                        "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50",
                        selectTime == 45 &&
                          "border px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50"
                      )}
                    >
                      <p
                        className={clsx(
                          "w-full text-primary-500",
                          selectTime == 45 &&
                            "group-hover:text-white text-white"
                        )}
                      >
                        45 Mins
                      </p>
                    </button>
                    <button
                      onClick={() => {
                        setSelectTime(60);
                        setSelectType("slot ");
                      }}
                      className={clsx(
                        "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50",
                        selectTime == 60 &&
                          "border px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50"
                      )}
                    >
                      <p
                        className={clsx(
                          "w-full text-primary-500",
                          selectTime == 60 &&
                            "group-hover:text-white text-white"
                        )}
                      >
                        60 Mins
                      </p>
                    </button>
                  </div>
                  <>
                    <label
                      className="text-gray-900 font-bold capitalize text-sm"
                      htmlFor="date"
                    >
                      Select A Date
                    </label>
                    <div className="relative w-full  mt-1">
                      <button
                        onClick={() => setIsOpenVideo((prev) => !prev)}
                        className="flex items-center w-[100%]  gap-2 bg-white px-4 py-2 border border-primary-500 rounded-md shadow-sm hover:bg-gray-50"
                      >
                        <AiOutlineCalendar className="w-5 h-5 text-primary-600" />
                        <span className="text-primary-500 text-sm">
                          {selectedVideo
                            ? format(selectedVideo, "PPP")
                            : "Select a date"}
                        </span>
                      </button>

                      {isOpenVideo && (
                        <div
                          ref={calendarRef}
                          className="absolute z-10 mt-2 bg-white p-4 rounded-lg shadow-lg"
                        >
                          <DayPicker
                            mode="single"
                            selected={selectedVideo}
                            onSelect={handleSelectVideo}
                            disabled={{ before: today, after: maxDate }}
                            modifiersClassNames={{
                              selected: "bg-primary-500 text-white",
                              today: "bg-gray-200",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <br />
                    <label
                      className="text-gray-900 font-bold capitalize text-sm"
                      htmlFor="date"
                    >
                      Select Slot Timing
                    </label>
                    <div className="flex gap-5 flex-wrap mt-1">
                      {filteredSlots?.map(({ slots, slotsDate, _id }) =>
                        slots?.map(({ time, booked, _id: slotId, status }) => (
                          <button
                            disabled={booked}
                            onClick={() => {
                              setSelectTimeHour(time);
                              setSelectType("slot");
                              setSelectedTimeSlot({
                                date: slotsDate,
                                slot: time,
                                _id: slotId,
                              });
                            }}
                            key={slotId}
                            className={clsx(
                              "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50",
                              selectTimeHour == time &&
                                "border  px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50"
                            )}
                          >
                            <p
                              className={clsx(
                                "w-full text-primary-500",
                                selectTimeHour == time &&
                                  "group-hover:text-white text-white"
                              )}
                            >
                              {moment(time, "HH:mm").format("hh:mm A")}
                            </p>
                          </button>
                        ))
                      )}
                    </div>
                  </>
                </>
              ) : (
                <></>
              )}
              <div className="flex gap-5 flex-wrap mt-3">
                <AppButton
                  flexed
                  onClick={() => setConfirmModel(true)}
                  disabled={
                    callType === "video"
                      ? (selectTime === 45 || selectTime === 60) &&
                        selectTimeHour &&
                        selected
                      : !callType
                  }
                  filled
                >
                  {callType === "chat"
                    ? "Start a chat"
                    : callType === "audio"
                    ? "Book a call"
                    : "Book a session"}
                </AppButton>
              </div>

              {callType == "audio" ? (
                <>
                  <div className="flex gap-5 flex-wrap mt-3">
                    <button
                      onClick={() => {
                        setSelectTime(45);
                        setSelectType("slot");
                      }}
                      className={clsx(
                        "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50",
                        selectTime == 45 &&
                          "border px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50"
                      )}
                    >
                      <p
                        className={clsx(
                          "w-full text-primary-500",
                          selectTime == 45 &&
                            "group-hover:text-white text-white"
                        )}
                      >
                        45 Mins
                      </p>
                    </button>
                    <button
                      onClick={() => {
                        setSelectTime(60);
                        setSelectType("slot ");
                      }}
                      className={clsx(
                        "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50",
                        selectTime == 60 &&
                          "border px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50"
                      )}
                    >
                      <p
                        className={clsx(
                          "w-full text-primary-500",
                          selectTime == 60 &&
                            "group-hover:text-white text-white"
                        )}
                      >
                        60 Mins
                      </p>
                    </button>
                  </div>
                  {selectTime == 45 || selectTime == 60 ? (
                    <>
                      <div className="relative w-full  mt-3">
                        <div>
                          <label className="text-gray-900 font-bold capitalize text-sm mb-1">
                            Select session date
                          </label>
                          <button
                            onClick={() => setIsOpen((prev) => !prev)}
                            className=" mt-1 flex w-[100%] items-center gap-2 bg-white px-4 py-2 border border-primary-500 rounded-md shadow-sm hover:bg-gray-50"
                          >
                            <AiOutlineCalendar className="w-5 h-5 text-primary-600" />
                            <span className="text-primary-500 text-sm">
                              {selected
                                ? format(selected, "PPP")
                                : "Select a date"}
                            </span>
                          </button>

                          {isOpen && (
                            <div
                              ref={calendarRef}
                              className="absolute z-10 mt-2 bg-white p-4 rounded-lg shadow-lg"
                            >
                              <DayPicker
                                mode="single"
                                selected={selected}
                                onSelect={handleSelect}
                                disabled={{ before: today, after: maxDate }}
                                modifiersClassNames={{
                                  selected: "bg-primary-500 text-white",
                                  today: "bg-gray-200",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="flex flex-col flex-wrap gap-1 mt-3">
                          <div>
                            <label className="text-gray-900 font-bold capitalize text-sm mb-1">
                              Select Slot Timing
                            </label>
                          </div>
                          <div>
                            {filteredSlots?.map(({ slots, slotsDate, _id }) =>
                              slots?.map(
                                ({ time, booked, _id: slotId, status }) => (
                                  <button
                                    disabled={booked}
                                    onClick={() => {
                                      setSelectTimeHour(time);
                                      setSelectType("slot");
                                      setSelectedTimeSlot({
                                        date: slotsDate,
                                        slot: time,
                                        _id: slotId,
                                      });
                                    }}
                                    key={slotId}
                                    className={clsx(
                                      "border px-5 py-1 border-primary-500 rounded-lg cursor-pointer group disabled:opacity-50 mr-3",
                                      selectTimeHour == time &&
                                        "border  px-5 py-1 bg-primary-500 rounded-lg cursor-pointer group disabled:opacity-50 mr-3"
                                    )}
                                  >
                                    <p
                                      className={clsx(
                                        "w-full text-primary-500",
                                        selectTimeHour == time &&
                                          "group-hover:text-white text-white"
                                      )}
                                    >
                                      {moment(time, "HH:mm").format("hh:mm A")}
                                    </p>
                                  </button>
                                )
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="flex gap-5 flex-wrap mt-3">
                    <AppButton
                      flexed
                      onClick={() => {
                        if (selectTime == 45 || selectTime == 60) {
                          if (!selectedTimeSlot) {
                            return;
                          }
                          setConfirmModel(true);
                        }
                      }}
                      disabled={
                        (selectTime === 45 || selectTime === 60) &&
                        selectTimeHour !== "" &&
                        selected
                          ? false
                          : true
                      }
                      filled
                    >
                      Book a session
                    </AppButton>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div> */}

            {/* Here is my created component */}
            <div className="max-w-3xl mx-auto p-5">
              {/* Step 1: Select type */}
              <div className="mb-6">
                <h2 className="text-xl font-bold text-gray-900 mb-2">Choose Session Type</h2>
                <div className=" gap-3 mt-4 grid grid-cols-3 flex-wrap">
                  <button
                    onClick={() => {
                      setCallType("chat");
                      setDuration(null);
                      setSessionType("");
                      setSelectedDate(undefined);
                    }}
                    className={`border px-4 py-2 rounded-lg flex items-center gap-2 ${callType === "chat" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570]"
                      }`}
                  >
                    <AiOutlineMessage />
                    Chat
                  </button>
                  <button
                    onClick={() => {
                      setCallType("audio");
                      setDuration(null);
                      setSessionType("");
                      setSelectedDate(undefined);
                    }}
                    className={`border px-4 py-2 rounded-lg flex items-center gap-2 ${callType === "audio" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570]"
                      }`}
                  >
                    <AiOutlinePhone />
                    Audio
                  </button>
                  <button
                    onClick={() => {
                      setCallType("video");
                      setDuration(null);
                      setSessionType("");
                      setSelectedDate(undefined);
                    }}
                    className={`border px-4 py-2 rounded-lg flex items-center gap-2 ${callType === "video" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570]"
                      }`}
                  >
                    <AiOutlineVideoCamera />
                    Video
                  </button>
                </div>
              </div>

              {/* Chat durations */}
              {callType === "chat" && (
                <div>
                  <h2 className="text-[16px] font-semibold mb-2 text-gray-800">Select Chat Duration</h2>

                  {/* Quick duration buttons */}
                  <div className="grid grid-cols-4 flex-wrap gap-2 mb-4">
                    {durations.map((d) => (
                      <button
                        key={d}
                        onClick={() => {
                          setSelectedDuration(d);
                          setPreferredTime(""); // clear custom time if preset selected
                        }}
                        className={`border px-4 py-1 rounded-lg 
              ${selectedDuration === d
                            ? "bg-[#D86570] text-white"
                            : "border-[#D86570] text-[#D86570] "
                          }`}
                      >
                        {d} min
                      </button>
                    ))}
                  </div>

                  <div className="mb-2 text-gray-600">OR</div>

                  {/* Input for preferred time */}
                  <label className="block text-[16px] font-semibold mb-2 text-gray-800">
                    Enter preferred time (in minutes)
                  </label>
                  <input
                    type="number"
                    min={1}
                    value={preferredTime}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPreferredTime(value === "" ? "" : parseInt(value));
                      setSelectedDuration(null);
                    }}
                    placeholder="e.g., 12"
                    className="border rounded px-3 py-1 w-full focus:outline-none focus:border-[#D86570]"
                  />

                  <div className="mt-4 text-gray-800">
                    Selected Duration:{" "}
                    <strong>
                      {selectedDuration
                        ? `${selectedDuration} min`
                        : preferredTime
                          ? `${preferredTime} min`
                          : "None"}
                    </strong>
                  </div>
                </div>
              )}

              {/* Audio & Video durations */}
              {(callType === "audio" || callType === "video") && (
                <div>
                  <h3 className="text-[16px] font-semibold text-gray-700 mb-2">Select Duration (minutes)</h3>
                  <div className="grid grid-cols-4 gap-3 flex-wrap">
                    {audioVideoDurations.map((d) => (
                      <button
                        key={d}
                        onClick={() => setDuration(d)}
                        className={`border px-4 py-1 rounded-lg ${duration === d ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570] "
                          }`}
                      >
                        {d} min
                      </button>
                    ))}
                  </div>

                  {duration && (
                    <div className="mb-4 mt-5">
                      <p className="text-gray-700 text-[16px] font-semibold mb-2">Select category:</p>
                      <div className="flex flex-wrap gap-2">
                        {categories.map((cat) => (
                          <button
                            key={cat}
                            onClick={() => setCategory(cat)}
                            className={`border px-3 py-1 rounded-lg ${category === cat ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570] "
                              }`}
                          >
                            {cat}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {duration && category && (
                    <div className="mt-5">
                      <h3 className="text-[16px] font-semibold text-gray-700 mb-2">Choose Session Plan</h3>
                      <div className="grid grid-cols-1 gap-3 flex-wrap">
                        <button
                          onClick={() => setSessionType("single")}
                          className={`border px-4 py-2 rounded-lg ${sessionType === "single" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570] "
                            }`}
                        >
                          Single Session
                        </button>
                        <button
                          onClick={() => setSessionType("package3")}
                          className={`border px-4 py-2 rounded-lg ${sessionType === "package3" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570] "
                            }`}
                        >
                          3 Sessions Package
                        </button>
                        <button
                          onClick={() => setSessionType("package6")}
                          className={`border px-4 py-2 rounded-lg ${sessionType === "package6" ? "bg-[#D86570] text-white" : "border-[#D86570] text-[#D86570] "
                            }`}
                        >
                          6 Sessions Package
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Date picker after choosing plan */}
              {(sessionType === "single" || sessionType === "package3" || sessionType === "package6") && (
                <div className="mt-5">
                  <h3 className="text-[16px] font-semibold text-gray-700 mb-2">Select Start Date</h3>
                  <button
                    onClick={() => setIsDateOpen(!isDateOpen)}
                    className="flex items-center gap-2 border border-[#D86570] px-4 py-2 rounded w-full"
                  >
                    <AiOutlineCalendar className="text-[#D86570] " />
                    <span className="text-[#D86570] text-sm">
                      {selectedDate ? format(selectedDate, "PPP") : "Select a date"}
                    </span>
                  </button>
                  {isDateOpen && (
                    <div className="mt-3 bg-white p-3 rounded shadow">
                      <DayPicker
                        mode="single"
                        selected={selectedDate}
                        onSelect={(date) => {
                          setSelectedDate(date);
                          setIsDateOpen(false);
                        }}
                      />
                    </div>
                  )}


                </div>
              )}
              <button
              onClick={() => setScheduleModel(true)}
                disabled={
                  callType === "chat"
                    ? !selectedDuration && !preferredTime
                    : !selectedDate
                }
                className={`mt-5 w-full py-2 rounded text-white ${(callType === "chat"
                  ? selectedDuration || preferredTime
                  : selectedDate)
                  ? "bg-[#D86570]"
                  : "bg-gray-300 cursor-not-allowed"
                  }`}
              >
                {callType === "chat"
                  ? "Book Chat"
                  : sessionType === "single"
                    ? `Book Single ${callType} Session`
                    : sessionType === "package3"
                      ? `Book 3 ${callType} Sessions`
                      : sessionType === "package6"
                        ? `Book 6 ${callType} Sessions`
                        : `Book ${callType} Sessions`}
              </button>
            </div>




          </div>
        </div>
      </div>
      <Dialog
        open={scheduleModel}
        onClose={() => setScheduleModel(false)}
        className="fixed inset-0 z-50 overflow-y-scroll flex w-screen items-center justify-center bg-black/30 p-4 transition duration-300 ease-out data-[closed]:opacity-0"
      >
        <DialogPanel className="w-[40%] space-y-4 bg-white p-5 mt-20">
          <DialogTitle>
            Selected Time Slot -
            {moment(selectedTimeSlot.date).format("DD-MM-YYYY")}{" "}
            {moment(selectedTimeSlot.slot, "HH:mm").format("hh:mm A")}
          </DialogTitle>
          <div className="my-5">
            <div className="flex gap-3 items-center">
              <AiOutlineMessage size={30} className="fill-primary-500" />
              <p className="text-gray-900 capitalize font-bold">
                Chat with {mentor?.data?.name?.firstName}{" "}
                {mentor?.data?.name?.lastName.charAt(0)}.
              </p>
            </div>
            <p className="text-gray-500 my-2">
              Chat with the expert and get instant guidance
            </p>
            <h6 className="text-right">
              Wallet Effect {wallet?.data?.balance - selectedPrice}
            </h6>
            <h6 className="my-3 font-semibold">Select Service Category</h6>
            <div className="flex items-center gap-3">
              {packages?.data
                .filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) =>
                        (t?.categoryId as ICategoryProps)?._id ===
                        (value?.categoryId as ICategoryProps)?._id
                    )
                )
                .map((packageList) => (
                  <div className="flex items-center gap-3">
                    {packageList?.subServices?.length === 0 && (
                      <AppButton
                        outlined={
                          selectedCategory ===
                          (packageList?.categoryId as ICategoryProps)?._id
                        }
                        key={packageList?._id}
                        onClick={() =>
                          setSelectedCategory(
                            (packageList?.categoryId as ICategoryProps)?._id
                          )
                        }
                      >
                        {(packageList?.categoryId as ICategoryProps)?.title}
                      </AppButton>
                    )}
                  </div>
                ))}
            </div>
            <div className={clsx("flex items-center gap-3")}>
              {packages?.data
                ?.filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) =>
                        (t.categoryId as ICategoryProps)._id ===
                        (value.categoryId as ICategoryProps)._id
                    )
                )
                ?.map((packageList) => (
                  <>
                    <div className="w-full">
                      {packageList?.subServices?.length !== 0 &&
                        packageList?.subServices?.map((subService) => (
                          <div
                            key={subService?._id}
                            className="flex items-center justify-between"
                          >
                            <h6 className="capitalize text-lg">
                              {subService?.title}
                            </h6>
                            <AppButton
                              onClick={() =>
                                setSelectedPrice(subService?.price)
                              }
                              outlined={selectedPrice === subService?.price}
                            >
                              <p>{subService?.price}</p>
                            </AppButton>
                          </div>
                        ))}
                    </div>
                  </>
                ))}
            </div>
            <h6 className="text-right my-4 text-green-500">
              Your Wallet Amount Will be charged as {selectedPrice}
            </h6>
            <div className="flex items-center gap-3 mt-3">
              <AppButton
                outlined
                flexed
                onClick={() => {
                  setSelectedPrice(
                    packages?.data
                      ?.filter(
                        (prop) =>
                          (prop?.categoryId as ICategoryProps)._id ===
                          selectedCategory
                      )
                      ?.find((prop) => prop?.packageType === "chat")?.price
                  );
                  setConfirmModel(true);
                  setCallType("chat");
                }}
              >
                <AiOutlineMessage size={20} />
                {packages?.data
                  .filter(
                    (prop) =>
                      (prop.categoryId as ICategoryProps)._id ===
                      selectedCategory
                  )
                  .find((prop) => prop?.packageType === "chat")?.price ||
                  selectedPrice}
              </AppButton>
              <AppButton
                outlined
                flexed
                onClick={() => {
                  setSelectedPrice(
                    packages?.data
                      .filter(
                        (prop) =>
                          (prop?.categoryId as ICategoryProps)._id ===
                          selectedCategory
                      )
                      ?.find((prop) => prop?.packageType === "audio")?.price
                  );
                  setConfirmModel(true);
                  setCallType("audio");
                }}
              >
                <AiOutlinePhone size={20} />
                {
                  packages?.data
                    ?.filter(
                      (prop) =>
                        (prop?.categoryId as ICategoryProps)._id ===
                        selectedCategory
                    )
                    ?.find((prop) => prop?.packageType === "audio")?.price
                }
              </AppButton>
              <AppButton
                outlined
                flexed
                onClick={() => {
                  setSelectedPrice(
                    packages?.data
                      .filter(
                        (prop) =>
                          (prop?.categoryId as ICategoryProps)._id ===
                          selectedCategory
                      )
                      ?.find((prop) => prop?.packageType === "video")?.price
                  );
                  setConfirmModel(true);
                  setCallType("video");
                }}
              >
                <AiOutlineVideoCamera size={20} />
                {
                  packages?.data
                    .filter(
                      (prop) =>
                        (prop?.categoryId as ICategoryProps)._id ===
                        selectedCategory
                    )
                    ?.find((prop) => prop?.packageType === "video")?.price
                }
              </AppButton>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
      <Dialog
        open={confirmModel}
        onClose={() => setConfirmModel(false)}
        className="fixed inset-0 z-50 overflow-y-scroll flex w-screen items-center justify-center bg-black/30 p-4 transition duration-300 ease-out data-[closed]:opacity-0"
      >
        <DialogPanel className="w-[40%] space-y-4 bg-white p-5 mt-20">
          <DialogTitle>Book a call</DialogTitle>
          <div className="my-5">
            <div className="flex gap-3 items-center">
              <AiOutlineMessage size={30} className="fill-primary-500" />
              <p className="text-gray-900 capitalize font-bold">
                Chat with {mentor?.data?.name?.firstName}{" "}
                {mentor?.data?.name?.lastName.charAt(0)}.
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-gray-500 my-2">
                Chat with the expert and get instant guidance
              </p>
              <h6 className="text-right my-2">
                Wallet Balance :{" "}
                {wallet?.data?.balance ? wallet?.data?.balance : 0}
              </h6>
            </div>
            <h6 className="my-3 font-semibold">Select Service Category</h6>
            <div className="flex items-center gap-3">
              {packages?.data
                .filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) =>
                        (t?.categoryId as ICategoryProps)?._id ===
                        (value?.categoryId as ICategoryProps)?._id
                    )
                )
                .map((packageList) => (
                  <div className="flex items-center gap-3">
                    {packageList?.subServices?.length === 0 && (
                      <AppButton
                        outlined={true}
                        filled={
                          selectedCategory ===
                          (packageList?.categoryId as ICategoryProps)?._id
                        }
                        key={packageList?._id}
                        onClick={() => {
                          setSelectedCategory(
                            (packageList?.categoryId as ICategoryProps)?._id
                          );
                          setSelectedPrice(packageList?.price);
                        }}
                      >
                        {(packageList?.categoryId as ICategoryProps)?.title}
                      </AppButton>
                    )}
                  </div>
                ))}
            </div>
            {/* Wallet Balance {wallet?.data?.balance}<br/> */}
            {selectedCategory ? (
              <>
                <h6 className="my-3 font-semibold">Price Breakup</h6>

                <table className="table-auto w-full border-none border-gray-300">
                  <tbody>
                    <tr>
                      <td className="border-none px-0 py-2 ">
                        Service price for {selectTime} minutes ({selectedPrice}{" "}
                        per min)
                      </td>
                      <td className="border-none px-0 py-2 font-semibold">
                        {selectTime * selectedPrice}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-none px-0 py-2 ">GST charges</td>
                      <td className="border-none px-0 py-2 font-semibold">0</td>
                    </tr>

                    <tr>
                      <td className="border-none px-0 py-2 ">Total Amount</td>
                      <td className="border-none px-0 py-2 font-semibold">
                        {selectTime * selectedPrice}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : (
              <></>
            )}

            <div className="flex gap-3 mt-2  py-3">
              <input
                type="checkbox"
                className="w-4 mt-1 rounded-full h-4"
                name="privacy"
                id="privacy"
                checked={accept}
                onChange={handlePrivacyAccept}
              />
              <Box className="select-none">
                Accept{" "}
                <span
                  onClick={() => {
                    navigate("/terms-and-condition");
                  }}
                  className="underline text-primary-500 cursor-pointer"
                >
                  Terms & Condition
                </span>{" "}
                &{" "}
                <span
                  onClick={() => {
                    navigate("/privacy-policy");
                  }}
                  className="underline text-primary-500 cursor-pointer"
                >
                  Privacy Policy
                </span>
                {showLinks && (
                  <Box as="span">
                    <Link
                      to="/refund-policy"
                      className="underline mx-2 text-primary-500 cursor-pointer"
                    >
                      Refund Policy
                    </Link>

                    <Link
                      to="/tripartite-service"
                      className="underline mx-2 text-primary-500 cursor-pointer"
                    >
                      Tri-Partite Service Agreement
                    </Link>
                    <a
                      href="/Annexure-C.pdf"
                      className="underline mx-2 text-primary-500 cursor-pointer"
                    >
                      Annexure C{" "}
                    </a>
                  </Box>
                )}
                <Box
                  as="span"
                  className="font-semibold ml-2 text-md text-primary-500 cursor-pointer"
                  onClick={toggleLinks}
                >
                  {showLinks ? "Less" : "More"}
                </Box>
              </Box>
            </div>
            <div className={clsx("flex items-center gap-3")}>
              {packages?.data
                ?.filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) =>
                        (t.categoryId as ICategoryProps)._id ===
                        (value.categoryId as ICategoryProps)._id
                    )
                )
                ?.map((packageList) => (
                  <>
                    <div className="w-full">
                      {packageList?.subServices?.length !== 0 &&
                        packageList?.subServices?.map((subService) => (
                          <div
                            key={subService?._id}
                            className="flex items-center justify-between"
                          >
                            <h6 className="capitalize text-lg">
                              {subService?.title}
                            </h6>
                            <AppButton
                              onClick={() =>
                                setSelectedPrice(subService?.price)
                              }
                              outlined={selectedPrice === subService?.price}
                            >
                              <p>{subService?.price}</p>
                            </AppButton>
                          </div>
                        ))}
                    </div>
                  </>
                ))}
            </div>
            {selectedPrice ? (
              <>
                <h6 className="text-right my-4 text-green-500">
                  Your Wallet Amount Will be charged as{" "}
                  {selectTime * selectedPrice}
                </h6>
              </>
            ) : (
              <></>
            )}

            <div className="flex items-center gap-3 mt-3">
              <AppButton
                outlined
                flexed
                filled
                loading={isBookSlotLoading}
                disabled={accept && selectedPrice ? false : true}
                onClick={() => {
                  localStorage.setItem("time", selectTime as string);
                  selectTime * selectedPrice >
                    (wallet?.data?.balance ? wallet?.data?.balance : 0)
                    ? setShowModal(true)
                    : BookSlot({
                      callType,
                      userId: profile?.data._id as string,
                      slotId: selectedTimeSlot._id,
                      mentorId: mentor?.data._id as string,
                      type: selectType as string,
                      time: selectTime as number,
                    });
                }}
              >
                Pay Now
              </AppButton>
            </div>
            {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-sm">
                  <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                    Insufficient Balance
                  </h2>
                  <p className="text-gray-600 text-lg mb-6">
                    Your wallet has not enough balance !!
                  </p>
                  <div className="flex justify-end space-x-3">
                    <button
                      onClick={() => setShowModal(false)}
                      className="px-4 py-2 rounded-lg text-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        navigate("/user/my-profile", {
                          state: { tabIndex: 1 },
                        });

                        localStorage.setItem(
                          "payment-redirection",
                          `user/mentor/details/${mentor.data._id}`
                        );
                      }}
                      className="px-4 py-2 text-lg rounded-lg bg-primary-500 text-white hover:bg-primary-700 transition"
                    >
                      Purchase Buddy Coins
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </DialogPanel>
      </Dialog>
    </MainLayout>
  );
};
